module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAPFJREFUWEftlcENwjAMRX+yAyzBhRWYgzWAqj3lloYyBnPADByYggF6qlUFFQlVTeqmiICUHN04fvl2fgUiLxG5PhJAUiAp8B8KFEWxbppmK6U8aq0fPu/I83xBRAcAZ2PMbcxnWApkWVYB2AG4Syk3Loiu+BXASghRlWVpQbyLBfB+sAuCs2eIhAVgE30FQovbc9kALggbJ6Kn7GMtmqXAK7l/2y4eVHyyAg4IG/YOp28KJ7XgJwCitmBo2r82hFGfIeedc/YEP0OuFSullnVdXzpPOBlj9h+x4ug/o7FbzPke5ANzCvZzE0BSICkQXYEWm8TGIVjQajEAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/newStatic/img/dialog_close.png
// module id = Jlu4
// module chunks = 87